import { useState, useEffect } from "react";
import { DrawerComponent, Modal } from "src/components/DialogComponent";
import Button from "src/components/Button";
import TGButton from "src/components/ui/TGButton";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _ from "lodash";
import { addItemRequest, deleteItemRequest, getItemsRequest, updateItemRequest } from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import Form from "src/components/Form";
import { selectGetItemStatus, selectItem, selectItems } from "src/modules/spItems/selectors";
import Loading from "src/components/Loading";
import { myTasks5WayDependListName, myTasksDeviationReportDependListName, myTasksDeviationReportKpiByTriggerListName, myTasksDeviationReportTriggersListName, myTasksKpiByTriggerListName, myTasksLocationsListName, myTasksTriggersListName } from "src/api/config/myTasksLists.config";
import { clearItem, getItem, getItems } from "src/modules/spItems/actions";
import moment from "moment";
import { useSearchParams } from "react-router-dom";
import { myTask5WayCommentsFilesListName, myTasks5WayCommentsListName, myTasks5WayEditorListName, myTasks5WayListName, myTasksSDCA5WayListName } from "src/api/config/myTasks5Way.config";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { twMerge } from "tailwind-merge";
import { ArrowDown, ArrowUp } from "src/components/ui-icons/card";
import { RootState } from "src/store/rootReducer";
import { addUsers } from "src/modules/users/actions";
import Tree from "./components/tree";
import { Medal } from "src/components/ui-icons/myTasks/medal";
import SDCA from "./components/sdca/sdca";
import Comments from "src/modules/comments";
import Statuses from "./components/statuses";
import { TooltipItem } from "src/utils/Tooltip";
import { SettingsIcon } from "src/components/ui-icons/myTasks/settings";
import { CancelIcon } from "src/components/ui-icons/myTasks/cancel";
import { DownloadWithHoverIcon } from "src/components/ui-icons/upload/DownloadIcon";
import { useNavigate } from "react-router-dom";
import { myTaskActionsListName } from "src/api/config/myTasksActions.config";
import { emailsSender, MT5WhyCommentsFiles, MTActionCommentsFiles, paramsListName, siteUrl } from "src/api/config";
import { emailAPI } from "src/utils/api.utils";
import PptxGenJS from "pptxgenjs";
import html2canvas from 'html2canvas';
import { actionsStatus, fiveWhyStatus, FiveWhyType, isStrapi } from "src/api/config/systemSwitch";
import AddActionInComponent from "../../mytasks/addAction/inComponent";
import { wrapTreeWithCategory } from "./components/tree/constants/config";
import Rate5Why from "./components/rate5Why/Rate5Why";
import { fetchRateByCardId } from "./api/rate5Why.api";
import { RatingBadge } from "./components/RatingBadge/RatingBadge";
import Trash from "src/components/ui-icons/buttons/Trash";
import MaintenancePage from "src/pages/MaintenancePage";
import { RootStateWithAI } from "src/modules/AIAssistant/AIAssistant";
import { AiSelector } from "src/modules/AIAssistant/selectors";
import { runAI, runAIIdle } from "src/modules/AIAssistant/actions";
import { aILogListName } from "src/api/config/ai.config";
const { sendEmail } = emailAPI();

const Card5Way = ({ zIndex, open, setOpen, card5WayID, type }: { zIndex: number, open: boolean, setOpen: any, card5WayID: number, type: string }) => {
    const dispatch = useAppDispatch();
    const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
    const [fields, setFields] = useState<any>([
        {
            type: 'date',
            require: true,
            key: 'Date5Way',
            minDate: moment(new Date()).subtract(7, 'days').toDate(),
            maxDate: moment(new Date()).toDate(),
            title: 'Дата',
            placeholder: 'дд.мм.гггг',
            width: "w-[calc(33%-10px)]"
        },
        {
            type: 'select',
            require: true,
            key: 'Location',
            title: 'Локация',
            placeholder: 'Не выбрано',
            width: "w-[calc(33%-10px)]"
        },
        {
            type: 'select',
            require: true,
            key: 'Department',
            title: 'Отдел',
            placeholder: 'Не выбрано',
            width: "w-[calc(33%-10px)]"
        },
        {
            type: 'select',
            require: true,
            key: 'Region',
            title: 'Участок',
            placeholder: 'Не выбрано',
            width: "w-[calc(33%-10px)]"
        },
        {
            type: 'select',
            require: true,
            key: 'Trigger',
            title: type === FiveWhyType && 'Триггер 5Почему' || 'Триггер отчета об отклонении',
            placeholder: 'Не выбрано',
            width: "w-[calc(33%-10px)]"
        },
        {
            type: 'select',
            require: false,
            key: 'ProblemRepeat',
            title: 'Повторяющаяся проблема?',
            placeholder: 'Не выбрано',
            width: "w-[calc(33%-10px)]"
        },
        {
            type: 'number',
            require: false,
            key: 'ProblemsCount',
            min: 1,
            hide: true,
            title: 'Кол-во повторений',
            width: "w-[calc(16.5%-10px)]"
        },
        {
            type: 'select',
            require: false,
            key: 'KPI',
            hide: true,
            title: 'KPI',
            placeholder: 'Не выбрано',
            width: 'w-[calc(50%-10px)]'
        },
        {
            type: 'editors',
            key: 'Editors',
            title: 'Участники',
            width: 'w-full',
            type5Way: type,
            hide: false

        },
        {
            type: 'textArea',
            key: 'Description',
            require: false,
            title: 'Краткое описание проблемы (Что и где произошло)',
            placeholder: 'Введите краткое описание проблемы',
            width: 'w-full',
            hide: true
        },
        {
            type: 'textArea',
            key: 'Details',
            noticeIcon: true,
            showNoticeFiveWhyCard: type === FiveWhyType && true || false,
            notice: `<span class="w-full"><strong>Что?</strong> (Что случилось, в чем именно проблема?)<br/>
<strong>Где?</strong> (Где именно проблема в продукте/процессе и где была обнаружена?) <br/>
<strong>Когда?</strong> (Когда проблема началась, когда была обнаружена?) <br/>
<strong>Как?</strong> (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) <br/>
<strong>Кто?</strong> (Кто обнаружил проблему?) <br/>
<strong>Насколько велика проблема?</strong> (Количество затронутого продукта / минуты простоя, риски от проблемы)</span>`,
            require: true,
            title: 'Детальное описание проблемы',
            placeholder: "Детально опишите проблему",
            width: 'w-full'
        },
        // {
        //     type: 'select',
        //     require: true,
        //     key: 'Plan',
        //     title: 'План реагирования выполнен?',
        //     placeholder: 'Не выбрано',
        //     width: 'w-[calc(50%-10px)]'
        // },
        {
            type: 'textArea',
            key: 'Actions',
            require: true,
            showNoticeFiveWhyCard: type === FiveWhyType && true || false,
            title: 'Немедленные корректирующие действия и эффект от них',
            placeholder: 'Немедленные корректирующие действия и эффект от них',
            width: 'w-full'
        }
    ]);
    const [dependenceFields, setDependenceFields] = useState<any>({
        Location: null,
        Department: null,
        Region: null,
        Trigger: null,
    });
    const [dependenceFields5Way, setDependenceFields5Way] = useState<any>({
        Trigger: null
    });
    const [formData, setFormData] = useState<any>(null);
    const [defaultValues, setDefaultValues] = useState<any>({
        Date5Way: {
            startDate: new Date(),
            endDate: new Date()
        },
        Editors: ""
    });
    const card5Way: any = useAppSelector(state => selectItem(state, myTasks5WayListName));
    const editor: any = useAppSelector(state => selectItem(state, myTasks5WayEditorListName));
    const users: any = useAppSelector(selectUsers);
    const [checkLoadUsers, setCheckLoadUsers] = useState(false);
    const [customLoading, setCustomLoading] = useState(false);
    const [escalateLoading, setEscalateLoading] = useState(false);
    const [cancelLoading, setCancelLoading] = useState(false);
    const locations: any = useAppSelector(state => selectItems(state, myTasksLocationsListName));
    const dependencies: any = useAppSelector(state => selectItems(state, myTasks5WayDependListName));
    const dependenciesDeviationReport: any = useAppSelector(state => selectItems(state, myTasksDeviationReportDependListName));
    const dependenceTrigger: any = useAppSelector(state => selectItem(state, myTasksKpiByTriggerListName));
    const dependenceDeviationReportTrigger: any = useAppSelector(state => selectItem(state, myTasksDeviationReportKpiByTriggerListName));
    const triggers: any = useAppSelector(state => selectItems(state, myTasksTriggersListName));
    const triggersDeviationReport: any = useAppSelector(state => selectItems(state, myTasksDeviationReportTriggersListName));
    const statusCard5Way = useAppSelector((state) => selectGetItemStatus(state, myTasks5WayListName));
    const [get5Way, setGet5Way] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const [kpi, setKPI] = useState<any>(null);
    const statusUsers: string = useAppSelector((state: RootState) => state.users.status);
    const [showEditors, setShowEditors] = useState(false);
    const [detailProplem, setDetailProblem] = useState("");
    const [card5WayTree, setCard5WayTree] = useState<any>([]);
    const [openTree, setOpenTree] = useState(false);
    const [openRateDrawer, setOpenRateDrawer] = useState(false);
    const [rateDrawerViewMode, setRateDrawerViewMode] = useState(false);
    const [existingRateId, setExistingRateId] = useState<number | null>(null);
    const [existingRateDocumentId, setExistingRateDocumentId] = useState<string | null>(null);
    const [existingRateTotalWeight, setExistingRateTotalWeight] = useState<number | null>(null);
    const hasExistingRate = Boolean(existingRateId || existingRateDocumentId);
    const [showEditModeBtns, setShowEditModeBtns] = useState(false);
    const [escalateModal, setEscalateModal] = useState(false);
    const navigate = useNavigate();
    const [actions, setActions] = useState<any>([]);
    const [cancelModal, setCancelModal] = useState(false);
    const [returnToWorkModal, setReturnToWorkModal] = useState(false);
    const [viewFlag, setViewFlag] = useState(false);
    const [tempTriggers, setTempTriggers] = useState<any>([]);
    const [pptxLoading, setPptxLoading] = useState(false);
    const [query, setQuery] = useSearchParams();
    const [editCardFiveWhy, setEditCardFiveWhy] = useState(false);
    const [removeModal, setRemoveModal] = useState(false);
    const params: any = useAppSelector((state) => selectItems(state, paramsListName));
    const [problemInTree, setProblemInTree] = useState("");
    const [problemRepeatCounShow, setProblevRepeatCounShow] = useState<any>(null);
    const [confirmUseAiModal, setConfirmUseAiModal] = useState(false);
    const ai = useAppSelector((state: RootStateWithAI) => AiSelector(state));
    const [blockAiAgent, setBlockAiAgent] = useState(false);
    const [blockAiAgentNoDetail, setBlockAiAgentNoDetail] = useState(false);
    const [blockAiAgentNoTree, setBlockAiAgentNoTree] = useState(false);
    const [blockAiAgentProblem, setBlockAiAgentProblem] = useState(false);

    //Расставляем опции селектов локации и статических селектов
    useEffect(() => {
        if (currentUser.id && !viewMode) {
            setDefaultValues((prevState: any) => {
                return { ...prevState, Editors: currentUser.email }
            });
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]['key'] === 'Location') {
                    const options = locations.filter((location: any) => {
                        if (currentUser.isAdmin || (currentUser.isLocationEditorMyTasks && currentUser.isLocationEditorMyTasks.length > 0 && currentUser.isLocationEditorMyTasks.find((locationID: any) => locationID === location.ID)) || (currentUser.isLocationAdminMyTasks && currentUser.isLocationAdminMyTasks.length > 0 && currentUser.isLocationAdminMyTasks.find((locationID: any) => locationID === location.ID))) {
                            return true
                        } else {
                            return false
                        }
                    }).map((location: any) => {
                        return {
                            id: location.ID,
                            name: location.Title,
                            available: true
                        };
                    });
                    tempFieldsForm[i]['options'] = [...options];
                }
                if (tempFieldsForm[i]['key'] === 'KPI') {
                    tempFieldsForm[i]["disabled"] = true;
                }
                if (tempFieldsForm[i]['key'] === 'ProblemRepeat') {
                    tempFieldsForm[i]['options'] = [
                        {
                            id: 1,
                            name: 'Да'
                        },
                        {
                            id: 0,
                            name: 'Нет'
                        }
                    ]
                }
                // if (tempFieldsForm[i]['key'] === 'Plan') {
                //     tempFieldsForm[i]['options'] = [
                //         {
                //             id: 1,
                //             name: 'Да'
                //         },
                //         {
                //             id: 2,
                //             name: 'Нет'
                //         },
                //         {
                //             id: 3,
                //             name: 'План реагирования отсутствует'
                //         }
                //     ]
                // }
            }
            setFields([...tempFieldsForm]);
        }
    }, [locations, currentUser, viewMode]);

    useEffect(() => {
        if (!viewMode) {
            if (dependenceFields["Location"]) {
                setKPI(null);
                dispatch(getItems({ listName: type === FiveWhyType && myTasks5WayDependListName || myTasksDeviationReportDependListName, filters: { Location: dependenceFields["Location"]["id"] } }));
                const tempFieldsForm = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Department") {
                        tempFieldsForm[i]["disabled"] = false;
                    }
                    if (tempFieldsForm[i]["key"] === "Region") {
                        tempFieldsForm[i]["disabled"] = true;
                    }
                    if (tempFieldsForm[i]["key"] === "Trigger") {
                        tempFieldsForm[i]["disabled"] = true;
                    }
                }
                setFields([...tempFieldsForm]);
            }
            if (!dependenceFields["Location"]) {
                const tempFieldsForm = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Department" || tempFieldsForm[i]["key"] === "Region" || tempFieldsForm[i]["key"] === "Trigger") {
                        tempFieldsForm[i]["disabled"] = true;
                    }
                }
                setFields([...tempFieldsForm]);
            }
            if (dependenceFields["Department"]) {
                const tempFieldsForm = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Region") {
                        tempFieldsForm[i]["disabled"] = false;
                    }
                }
                setFields([...tempFieldsForm]);
            }
            if (dependenceFields["Region"]) {
                const tempFieldsForm = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Trigger") {
                        tempFieldsForm[i]["disabled"] = false;
                    }
                }
                setFields([...tempFieldsForm]);
            }
        }
    }, [dependenceFields, viewMode]);

    useEffect(() => {
        if (dependenceFields5Way["Trigger"] && !viewMode) {
            dispatch(getItem({ listName: type === FiveWhyType && myTasksKpiByTriggerListName || myTasksDeviationReportKpiByTriggerListName, filters: { Trigger: dependenceFields5Way["Trigger"]["id"] } }));
        }
    }, [dependenceFields5Way, viewMode]);

    //В списке зависимостей колонка называется Departament, а в списках с аудитами и отделами Department (буква a отличие)
    useEffect(() => {
        if (!viewMode) {
            const tempFieldsForm = [...fields];
            let tempDependencies: any = [];
            if (type === FiveWhyType) {
                tempDependencies = [...dependencies];
            } else {
                tempDependencies = [...dependenciesDeviationReport];
            }
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (dependenceFields["Location"]) {
                    if (tempFieldsForm[i]["key"] === "Department") {
                        const options = tempDependencies
                            .filter((dependence: any) => dependence.Location.ID === dependenceFields["Location"]["id"])
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Departament.ID,
                                    name: dependence.Departament.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual).length > 0 && _.uniqWith(options, _.isEqual) || [{
                            id: 0,
                            name: "Нет вариантов",
                            available: false
                        }];
                    }
                }
                if (dependenceFields["Department"]) {
                    if (tempFieldsForm[i]["key"] === "Region") {
                        const options = tempDependencies
                            .filter((dependence: any) => dependence.Departament.ID === dependenceFields["Department"]["id"])
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Region.ID,
                                    name: dependence.Region.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual).length > 0 && _.uniqWith(options, _.isEqual) || [{
                            id: 0,
                            name: "Нет вариантов",
                            available: false
                        }];
                    }
                }
                if (dependenceFields["Region"]) {
                    if (tempFieldsForm[i]["key"] === "Trigger") {
                        const options = tempDependencies
                            .filter((dependence: any) => dependence.Departament.ID === dependenceFields["Department"]["id"] && dependence.Region.ID === dependenceFields["Region"]["id"] && !dependence.Hide)
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Trigger.ID,
                                    name: dependence.Trigger.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual).length > 0 && _.uniqWith(options, _.isEqual) || [{
                            id: 0,
                            name: "Нет вариантов",
                            available: false
                        }];
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [dependencies, dependenciesDeviationReport, type, viewMode]);

    useEffect(() => {
        if (type === FiveWhyType) {
            const tempFieldsForm = [...fields];
            if (problemRepeatCounShow) {
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "ProblemsCount") {
                        tempFieldsForm[i]["hide"] = false;
                        tempFieldsForm[i]["width"] = "w-[calc(16.5%-10px)]"
                    }
                    if (tempFieldsForm[i]["key"] === "ProblemRepeat") {
                        tempFieldsForm[i]["width"] = "w-[calc(16.5%-10px)]"
                    }
                }
            } else {
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "ProblemsCount") {
                        tempFieldsForm[i]["hide"] = true;
                        tempFieldsForm[i]["width"] = "w-[calc(16.5%-10px)]"
                    }
                    if (tempFieldsForm[i]["key"] === "ProblemRepeat") {
                        tempFieldsForm[i]["width"] = "w-[calc(33%-10px)]"
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [problemRepeatCounShow]);

    useEffect(() => {
        if (formData && Object.keys(formData).length > 0 && !viewMode) {
            setCustomLoading(true);
            const sendData: any = {
                ID: formData.ID,
                Title: (type === FiveWhyType && "5Почему") || "Отчет об отклонении",
                Location: formData.Location.id,
                Department: formData.Department.id,
                Region: formData.Region.id,
                Trigger: formData.Trigger.id,
                KPI: formData.KPI.id,
                Description: (type === FiveWhyType && "5Почему") || "Отчет об отклонении",
                Actions: formData.Actions.trim() + " ",
                Date5Way: formData.Date5Way.startDate,
                Editors: formData.Editors,
                Details: formData.Details.trim() + " ",
                // Plan: formData.Plan.name,
                View: false,
                ProblemsCount: formData.ProblemsCount
            }
            if (formData.ProblemRepeat) {
                sendData["ProblemRepeat"] = formData.ProblemRepeat.id;
            }
            console.log('FORM_DATA_5WAY_CARD: ', formData);
            updateItemRequest({ listName: myTasks5WayListName, body: sendData }).then(ID5Way => {
                if (emailsSender) {
                    let peopleEmail: any = [];
                    formData.Editors.split(";").forEach((newEmail: string) => {
                        if (card5Way.Editors.indexOf(newEmail) === -1) {
                            peopleEmail = [...peopleEmail, newEmail];
                        }
                    });
                    if (peopleEmail.length > 0) {
                        const timestamp = moment().unix();
                        let emailsBody: any = [];
                        peopleEmail.forEach((email: string) => {
                            emailsBody = [...emailsBody, sendEmail({
                                Body: `Здравствуйте ${users[email] && users[email]["displayName"]},<br/><br/>Сотрудник ${currentUser.displayName} назначил Вас участником в <a href="${siteUrl}/dashboard/3?${type === FiveWhyType ? "5WayCard" : "deviationCard"}=${ID5Way}">${type === FiveWhyType ? "5Почему" : "Отчете об отклонении"}</a>`,
                                DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                                Title: type === FiveWhyType ? "Мои Задачи | Назначение участника 5Почему" : "Мои Задачи | Назначение участника Отчета об отклонении",
                                Subject: type === FiveWhyType ? "Мои Задачи | Назначение участника 5Почему" : "Мои Задачи | Назначение участника Отчета об отклонении",
                                Recepients: email,
                                CheckDoc: String(timestamp)
                            })]
                        });
                        Promise.all(emailsBody).then(() => {
                            setFormData(null);
                            setDefaultValues({
                                Date5Way: {
                                    startDate: new Date(),
                                    endDate: new Date()
                                },
                                Editors: ""
                            });
                            dispatch(clearItem({ listName: myTasks5WayEditorListName }));
                            dispatch(clearItem({ listName: myTasks5WayListName }));
                            setCustomLoading(false);
                            setGet5Way(!get5Way)
                        });
                    } else {
                        setFormData(null);
                        setDefaultValues({
                            Date5Way: {
                                startDate: new Date(),
                                endDate: new Date()
                            },
                            Editors: ""
                        });
                        dispatch(clearItem({ listName: myTasks5WayEditorListName }));
                        dispatch(clearItem({ listName: myTasks5WayListName }));
                        setCustomLoading(false);
                        setGet5Way(!get5Way)
                    }
                } else {
                    setFormData(null);
                    setDefaultValues({
                        Date5Way: {
                            startDate: new Date(),
                            endDate: new Date()
                        },
                        Editors: ""
                    });
                    dispatch(clearItem({ listName: myTasks5WayEditorListName }));
                    dispatch(clearItem({ listName: myTasks5WayListName }));
                    setCustomLoading(false);
                    setGet5Way(!get5Way)
                }
            });
        }
    }, [formData, viewMode]);

    useEffect(() => {
        if (!viewMode) {
            if (type === FiveWhyType && Object.keys(dependenceTrigger).length > 0) {
                setKPI({
                    id: dependenceTrigger['Kpi'].ID,
                    name: dependenceTrigger['Kpi'].Title
                });
            } else if (Object.keys(dependenceDeviationReportTrigger).length > 0) {
                setKPI({
                    id: dependenceDeviationReportTrigger['Kpi'].ID,
                    name: dependenceDeviationReportTrigger['Kpi'].Title
                });
            } else {
                setKPI({
                    id: 108, //Не применимо
                    name: 'Не применимо'
                });
            }
        }

    }, [dependenceTrigger, dependenceDeviationReportTrigger, type, viewMode]);

    useEffect(() => {
        if (card5WayID) {
            getItemsRequest({ listName: myTasks5WayListName, filters: { ID: card5WayID } }).then(results => {
                if (results.items.length === 0) {
                    if (type === FiveWhyType) {
                        alert("Карточка 5Почему не найдена или удалена");
                        query.delete("5WayCard");
                    } else {
                        alert("Карточка ОоО не найдена или удалена");
                        query.delete("deviationCard");
                    }
                    setQuery(query);
                    return;
                } else {
                    setCheckLoadUsers(false);
                    dispatch(getItem({ listName: myTasks5WayEditorListName, filters: { _x0035_Way: card5WayID } }));
                    dispatch(getItem({ listName: myTasks5WayListName, filters: { ID: card5WayID } }));
                }
            });
        }
    }, [card5WayID, get5Way]);

    useEffect(() => {
        return () => {
            dispatch(clearItem({ listName: myTasks5WayListName }))
        }
    }, []);

    useEffect(() => {
        if (statusCard5Way === 'SUCCESS' && !checkLoadUsers && Object.keys(users).length > 0 && !viewMode && tempTriggers.length > 0) {
            setCheckLoadUsers(true);
            let tempDefaultValues: any = {};
            setProblemInTree(card5Way.DetailsInTree || "");
            Object.keys(card5Way).map((key: string, idx: number) => {
                const field = card5Way[key];
                if (key === 'Date5Way') {
                    tempDefaultValues[key] = {
                        startDate: field.toDate(),
                        endDate: field.toDate(),
                    }
                } else if (key === 'Location' || key === 'Department' || key === 'Region' || key === 'KPI') {
                    tempDefaultValues[key] = {
                        id: field.ID,
                        name: field.Title
                    }
                } else if (key === 'Trigger') {
                    tempDefaultValues[key] = {
                        id: field,
                        name: tempTriggers.filter((trigger: any) => trigger.ID === field).length > 0 && tempTriggers.filter((trigger: any) => trigger.ID === field)[0]['Title']
                    }
                } else if (key === 'Author' || key === 'Tree' || key === 'Title') {
                    return false
                } else if (key === 'ProblemRepeat') {
                    if (field) {
                        tempDefaultValues[key] = {
                            id: 1,
                            name: 'Да'
                        }
                    } else {
                        tempDefaultValues[key] = {
                            id: 0,
                            name: 'Нет'
                        }
                    }
                } else {
                    tempDefaultValues[key] = field
                }
            });
            setDefaultValues((prevState: any) => {
                return { ...prevState, ...tempDefaultValues }
            });
            getItemsRequest({ listName: aILogListName, filters: { Card: card5WayID } }).then(results => {
                if (results.items.length > 0) {
                    dispatch(runAI({ type: 'FiveWhy', data: { id: card5WayID, historyOnly: true } }));
                }
            });
        }
    }, [statusCard5Way, users, checkLoadUsers, viewMode, tempTriggers]);

    useEffect(() => {
        if (card5Way && card5Way.Editors && card5Way.Editors.split(';').length > 0) {
            let emails: any = [];
            card5Way.Editors.split(';').map((email: string) => {
                emails = [...emails, email.trim()];
            });
            dispatch(addUsers(emails));
        }
        if (card5Way && Object.keys(card5Way).length > 0) {
            console.log('card5Way: ', card5Way);
            setCard5WayTree(card5Way.Tree && JSON.parse(card5Way.Tree) || []);
            setDetailProblem(card5Way.Details);
        }
    }, [card5Way]);

    useEffect(() => {
        if (!card5WayID || !open) return;
        const fetchExistingRate = async () => {
            try {
                const record = await fetchRateByCardId(card5WayID);
                setExistingRateId(record?.id ?? null);
                setExistingRateDocumentId(record?.documentId ?? null);
                setExistingRateTotalWeight(record?.TotalWeight ?? null);
            } catch {
                setExistingRateId(null);
                setExistingRateDocumentId(null);
                setExistingRateTotalWeight(null);
            }
        };
        fetchExistingRate();
    }, [card5WayID, open]);

    useEffect(() => {
        if (card5Way && Object.keys(card5Way).length > 0 && !viewFlag && card5Way.Editors && currentUser.email && card5Way.Editors.indexOf(currentUser.email) !== -1 && !card5Way.View) {
            setViewFlag(true);
            setCustomLoading(true);
            updateItemRequest({ listName: myTasks5WayListName, body: { ID: card5Way.ID, View: true } }).then(() => {
                setCustomLoading(false);
            })
        }
    }, [viewFlag, card5Way, currentUser]);

    // useEffect(() => {
    //     if (card5Way && Object.keys(card5Way).length > 0 && currentUser.id) {
    //         if (editor && Object.keys(editor).length > 0) {
    //             if (editor.Author.Email && editor.Author.Email.toLowerCase().trim() === currentUser.email) {
    //                 setViewMode(false);
    //             } else {
    //                 setViewMode(true);
    //             }
    //         } else {
    //             setViewMode(true);
    //         }
    //     }
    // }, [card5Way, editor, currentUser]);

    const addEditorHandle = (card5WayID: number) => {
        getItemsRequest({ listName: myTasks5WayEditorListName, filters: { _x0035_Way: card5WayID } }).then((results) => {
            const editorItems = results.items;
            if (editorItems.length === 0) {
                addItemRequest({
                    listName: myTasks5WayEditorListName, body: {
                        Title: `Редактирует от ${moment(new Date()).format('HH:mm DD.MM.YYYY')}`,
                        _x0035_Way: card5WayID,
                        Location: card5Way.Location.ID,
                        Department: card5Way.Department.ID,
                        Type5Way: type
                    }
                }).then(IDEditor => {
                    setGet5Way(!get5Way)
                });
            } else {
                setGet5Way(!get5Way)
            }
        });
    }

    useEffect(() => {
        if (card5Way && Object.keys(card5Way).length > 0 && currentUser.id) {
            if ((currentUser.isAdmin || currentUser.email === card5Way.Author.Email.toLowerCase().trim() || (card5Way.Editors && card5Way.Editors.indexOf(currentUser.email) !== -1) || (currentUser.isLocationEditorMyTasks && currentUser.isLocationEditorMyTasks.some((locationID: number) => locationID === card5Way.Location.ID)) || (currentUser.isLocationAdminMyTasks && currentUser.isLocationAdminMyTasks.some((locationID: number) => locationID === card5Way.Location.ID)))) { //&& viewMode
                setShowEditModeBtns(true);
            } else {
                setShowEditModeBtns(false);
            }
            if (type === 'DeviationReport' && !viewMode && card5Way.Trigger === 305) { //Эскалировано из 5Почему
                const tempFieldsForm: any = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Details" || tempFieldsForm[i]["key"] === "Actions") {
                        tempFieldsForm[i]["disabled"] = false
                    } else {
                        tempFieldsForm[i]["disabled"] = true
                    }
                }
                setFields([...tempFieldsForm]);
            }
            if (!viewMode && card5Way.Status && card5Way.Status.ID === fiveWhyStatus.cancel) { //Отменено
                const tempFieldsForm: any = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    tempFieldsForm[i]["disabled"] = true;
                }
                setFields([...tempFieldsForm]);
                setViewMode(true);
            }
            if (type === 'DeviationReport' && !viewMode && card5Way.Incident) { // Есть инцидент
                const tempFieldsForm: any = [...fields];
                for (let i = 0; i < tempFieldsForm.length; i++) {
                    if (tempFieldsForm[i]["key"] === "Location" || tempFieldsForm[i]["key"] === "Department" || tempFieldsForm[i]["key"] === "Region" || tempFieldsForm[i]["key"] === "Trigger") {
                        tempFieldsForm[i]["disabled"] = true
                    }
                }
                setFields([...tempFieldsForm]);
            }
        }
    }, [card5Way, currentUser, viewMode, dependenceFields]);

    const removeEditorHandle = (card5WayID: number) => {
        setGet5Way(!get5Way)
        // deleteItemRequest({ listName: myTasks5WayEditorListName, ID: editor.ID }).then(() => {

        // })
    }

    const escalateHandle = () => {
        const escalateTree = wrapTreeWithCategory(card5WayTree);
        setEscalateLoading(true);
        const sendData = {
            Title: 'Эскалировано из 5Почему',
            Location: defaultValues.Location.id,
            Department: defaultValues.Department.id,
            Region: defaultValues.Region.id,
            Trigger: 305, //Эскалировано из 5Почему
            KPI: 108, //Не применимо
            Description: 'Эскалировано из 5Почему',
            Actions: defaultValues.Actions.trim() + " ",
            Date5Way: new Date(),
            Editors: currentUser.email,
            Details: defaultValues.Details.trim() + " ",
            ProblemRepeat: defaultValues.ProblemRepeat.id,
            // Plan: defaultValues.Plan.name,
            Type5Way: 'DeviationReport',
            Escalate: card5WayID,
            Status: fiveWhyStatus.process,
            AuthorEmail: currentUser.email,
            Tree: JSON.stringify(escalateTree)
        }
        addItemRequest({ listName: myTasks5WayListName, body: sendData }).then(ID5Way => {
            updateItemRequest({ listName: myTasks5WayListName, body: { ID: card5WayID, Escalate: ID5Way, Status: fiveWhyStatus.escalate, ChangeStatusDate: new Date() } }).then(() => {
                if (emailsSender) {
                    const timestamp = moment().unix();
                    const emailBody = {
                        Body: `Здравствуйте ${users[card5Way.AuthorEmail] && users[card5Way.AuthorEmail]["displayName"]},<br/><br/>Примите к сведению, что <a href="${siteUrl}/dashboard/3?5WayCard=${card5Way.ID}">5Почему</a> был эскалирован на уровень Отчета об отклонении.`,
                        DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                        Title: 'Мои Задачи | 5Почему Эскалирован на уровень Отчета об отклонении',
                        Subject: 'Мои Задачи | 5Почему Эскалирован на уровень Отчета об отклонении',
                        Recepients: card5Way.AuthorEmail,
                        CheckDoc: String(timestamp)
                    };
                    Promise.all([sendEmail(emailBody)]).then(() => {
                        setEscalateModal(!escalateModal);
                        navigate(`/dashboard/3/deviation-reports?deviationCard=${ID5Way}`);
                        setEscalateLoading(false);
                    });
                } else {
                    setEscalateModal(!escalateModal);
                    navigate(`/dashboard/3/deviation-reports?deviationCard=${ID5Way}`);
                    setEscalateLoading(false);
                }
                // deleteItemRequest({ listName: myTasks5WayEditorListName, ID: editor.ID }).then(() => {

                // });
            });
        });
    }

    const cancelHandle = () => {
        updateItemRequest({ listName: myTasks5WayListName, body: { ID: card5WayID, Status: fiveWhyStatus.cancel, ChangeStatusDate: new Date() } }).then(() => {
            if (emailsSender) {
                const timestamp = moment().unix();
                if (type === FiveWhyType) {
                    const emailBody = {
                        Body: `Здравствуйте ${users[card5Way.AuthorEmail] && users[card5Way.AuthorEmail]["displayName"]},<br/><br/>Примите к сведению, что <a href="${siteUrl}/dashboard/3?5WayCard=${card5Way.ID}">5Почему</a> был отменен`,
                        DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                        Title: 'Мои Задачи | 5Почему отменен',
                        Subject: 'Мои Задачи | 5Почему отменен',
                        Recepients: card5Way.AuthorEmail,
                        CheckDoc: String(timestamp)
                    };
                    Promise.all([sendEmail(emailBody)]).then(() => {
                        setCancelModal(!cancelModal)
                        setGet5Way(!get5Way)
                    });
                } else {
                    const emailBody = {
                        Body: `Здравствуйте ${users[card5Way.AuthorEmail] && users[card5Way.AuthorEmail]["displayName"]},<br/><br/>Примите к сведению, что <a href="${siteUrl}/dashboard/3?deviationCard=${card5Way.ID}">Отчет об отклонении</a> был отменен`,
                        DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                        Title: 'Мои Задачи | Отчет об отклонении отменен',
                        Subject: 'Мои Задачи | Отчет об отклонении отменен',
                        Recepients: card5Way.AuthorEmail,
                        CheckDoc: String(timestamp)
                    };
                    Promise.all([sendEmail(emailBody)]).then(() => {
                        setCancelModal(!cancelModal)
                        setGet5Way(!get5Way)
                    });
                }
            } else {
                setCancelModal(!cancelModal)
                setGet5Way(!get5Way)
            }
            // deleteItemRequest({ listName: myTasks5WayEditorListName, ID: editor.ID }).then(() => {

            // })
        });
    }

    const returnToWorkHandle = () => {
        updateItemRequest({ listName: myTasks5WayListName, body: { ID: card5WayID, Status: fiveWhyStatus.process } }).then(() => {
            if (emailsSender && card5Way.AuthorEmail !== currentUser.email) {
                const timestamp = moment().unix();
                if (type === FiveWhyType) {
                    const emailBody = {
                        Body: `Здравствуйте ${users[card5Way.AuthorEmail] && users[card5Way.AuthorEmail]["displayName"]},<br/><br/>Примите к сведению, что сотрудник ${currentUser.displayName} вернул в работу <a href="${siteUrl}/dashboard/3?5WayCard=${card5Way.ID}">5Почему</a>`,
                        DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                        Title: 'Мои Задачи | 5Почему возвращен в работу',
                        Subject: 'Мои Задачи | 5Почему возвращен в работу',
                        Recepients: card5Way.AuthorEmail,
                        CheckDoc: String(timestamp)
                    };
                    Promise.all([sendEmail(emailBody)]).then(() => {
                        setReturnToWorkModal(!returnToWorkModal)
                        setGet5Way(!get5Way)
                    });
                } else {
                    const emailBody = {
                        Body: `Здравствуйте ${users[card5Way.AuthorEmail] && users[card5Way.AuthorEmail]["displayName"]},<br/><br/>Примите к сведению, что сотрудник ${currentUser.displayName} вернул в работу <a href="${siteUrl}/dashboard/3?deviationCard=${card5Way.ID}">Отчет об отклонении</a>`,
                        DateToBeSentAt: moment().subtract(12, 'hours').toDate(),
                        Title: 'Мои Задачи | Отчет об отклонении возвращен в работу',
                        Subject: 'Мои Задачи | Отчет об отклонении возвращен в работу',
                        Recepients: card5Way.AuthorEmail,
                        CheckDoc: String(timestamp)
                    };
                    Promise.all([sendEmail(emailBody)]).then(() => {
                        setReturnToWorkModal(!returnToWorkModal);
                        setGet5Way(!get5Way);
                        setViewMode(false);
                    });
                }
            } else {
                setReturnToWorkModal(!returnToWorkModal);
                setGet5Way(!get5Way);
                setViewMode(false);
            }
        });
    }

    useEffect(() => {
        if (cancelModal) {
            if (!_.isEmpty(card5Way) && !viewMode) {
                setCancelLoading(true);
                getItemsRequest({ listName: myTasksSDCA5WayListName, filters: { _x0035_Way: card5WayID } }).then(results => {
                    let arrRequests: any = [];
                    results.items.map(item => {
                        arrRequests = [...arrRequests, getItemsRequest({ listName: myTaskActionsListName, filters: { ImportantHashTag: `#5Почему_${item.ID}*` } })];
                    });
                    if (arrRequests.length > 0) {
                        Promise.all(arrRequests).then(values => {
                            let tempActions: any = [];
                            values.map(value => {
                                tempActions = [...tempActions, ...value.items];
                            });
                            setActions([...tempActions]);
                            setCancelLoading(false);
                        });
                    } else {
                        setActions([]);
                        setCancelLoading(false);
                    }
                });
            }
        }
    }, [cancelModal])

    useEffect(() => {
        if (triggersDeviationReport.length > 0 || triggers.length > 0) {
            if (type === FiveWhyType) {
                setTempTriggers([...triggers]);
            } else {
                setTempTriggers([...triggersDeviationReport]);
            }
        }
    }, [type, triggersDeviationReport, triggers]);

    const findSum = (arr: any) => {
        let sum = 0;

        for (let i = 0; i < arr.length; i++) {
            sum += arr[i];
        }

        return sum;
    }

    const importPPTXHandle = () => {
        if (card5Way && Object.keys(card5Way).length > 0) {
            setPptxLoading(true);
            const items = [card5Way];
            getItemsRequest({ listName: myTasksSDCA5WayListName, filters: { _x0035_Way: card5Way.ID } }).then(results => {
                const sdcaItems = [...results.items];
                let arrRequests: any = [];
                if (type === FiveWhyType) {
                    arrRequests = [...arrRequests, getItemsRequest({ listName: myTaskActionsListName, filters: { ImportantHashTag: `#5Почему_${card5Way.ID}*` } })];
                } else {
                    sdcaItems.map(item => {
                        arrRequests = [...arrRequests, getItemsRequest({ listName: myTaskActionsListName, filters: { ImportantHashTag: `#Отчет_об_отклонениях_${item.ID}*` } })];
                    });
                }
                Promise.all(arrRequests).then(values => {
                    let actions: any = [];
                    values.map(value => {
                        actions = [...actions, ...value.items];
                    });
                    const returnItems = items.map((item: any) => {
                        let currentActions: any = [];
                        if (type === FiveWhyType) {
                            currentActions = [...currentActions, ...actions.filter(
                                (action: any) => action.ImportantHashTag.indexOf(`#5Почему_${item.ID}`) !== -1
                            ).map((action: any) => {
                                return {
                                    numRoot: card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).map((treeItem: any, idx: number) => {
                                        return idx + 1
                                    }).join('') || '-',
                                    sdca: action.SDCA.get_lookupValue(),
                                    description: action.Description,
                                    date: moment(action.DateForDone).format('DD.MM.YYYY'),
                                    responsible: users[action.ResponsibleEmail]['displayName']
                                }
                            })]
                        } else {
                            const currentSdcaItems = sdcaItems.filter((sdcaItem: any) => sdcaItem._x0035_Way.get_lookupId() === item.ID);
                            currentSdcaItems.map((currentSdcaItem: any) => {
                                currentActions = [...currentActions, ...actions.filter(
                                    (action: any) => action.ImportantHashTag.indexOf(`#Отчет_об_отклонениях_${currentSdcaItem.ID}`) !== -1
                                ).map((action: any) => {
                                    return {
                                        numRoot: card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).map((treeItem: any, idx: number) => {
                                            if (treeItem.reason.trim() === currentSdcaItem.RootTree.trim()) {
                                                return idx + 1
                                            } else {
                                                return ''
                                            }
                                        }).join('') || '-',
                                        sdca: currentSdcaItem.SDCA.get_lookupValue(),
                                        description: action.Description,
                                        date: moment(action.DateForDone).format('DD.MM.YYYY'),
                                        responsible: users[action.ResponsibleEmail]['displayName']
                                    }
                                })]
                            });
                        }
                        return {
                            ...item,
                            actions: currentActions
                        };
                    });
                    const Card5WayWithActions: any = returnItems[0];
                    //@ts-ignore
                    const treeElem = document.querySelector('#screenshotTree');
                    //@ts-ignore
                    treeElem.style.display = 'flex';
                    //@ts-ignore
                    html2canvas(treeElem, {
                        useCORS: true,
                        allowTaint: true
                    }).then(function (canvas) {
                        //@ts-ignore
                        treeElem.style.display = 'none';
                        const urlScreenshotTree = canvas.toDataURL();
                        const heightScreen = canvas.height;
                        const widthScreen = canvas.width;
                        const pptx = new PptxGenJS();
                        pptx.defineLayout({ name: 'CUSTOM_LAYOUT', width: 22, height: 12.25 });
                        pptx.layout = 'CUSTOM_LAYOUT';
                        let slide = pptx.addSlide();
                        let rows: any = [];
                        let rowHHeight = [0.85, 0.77, 0.5, 0.5, 0.5, 0.77];
                        rows.push([
                            { text: `#${card5Way.ID}`, options: { align: "center", color: "ffffff", fill: '004465', hyperlink: { url: type === FiveWhyType && `${siteUrl}/dashboard/3/5-whys?5WayCard=${card5Way.ID}` || `${siteUrl}/dashboard/3/deviation-reports?deviationCard=${card5Way.ID}` } } },
                            { text: card5Way.Date5Way.format('DD.MM.YYYY'), options: { align: "center", color: "ffffff", fill: '004465', border: { type: 'solid', color: '004465' } } },
                            { text: type === FiveWhyType && '5ПОЧЕМУ' || 'ОТЧЕТ ОБ ОТКЛОНЕНИИ', options: { align: "center", color: "ffffff", fill: '004465', border: { type: 'solid', color: '004465' } } }
                        ]);
                        rows.push([
                            { text: 'Локация', options: { align: "center", color: "ffffff", fill: '00629B', colspan: 2, border: { type: 'solid', color: '004465' } } },
                            { text: 'Немедленные корректирующие действия', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } }
                        ])
                        rows.push([
                            { text: 'Локация: ', options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                            { text: card5Way.Location.Title, options: { align: "left", border: { type: 'solid', color: '004465' } } },
                            { text: card5Way.Actions, options: { rowspan: 3, align: "left", border: { type: 'solid', color: '004465' } } }
                        ]);
                        rows.push([
                            { text: 'Отдел: ', options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                            { text: card5Way.Department.Title, options: { align: "left", border: { type: 'solid', color: '004465' } } }
                        ]);
                        rows.push([
                            { text: 'Участок: ', options: { bold: true, align: "left", border: { type: 'solid', color: '004465' } } },
                            { text: card5Way.Region.Title, options: { align: "left", border: { type: 'solid', color: '004465' } } }
                        ]);
                        rows.push([
                            { text: 'Участники', options: { align: "center", color: "ffffff", fill: '00629B', colspan: 2, border: { type: 'solid', color: '004465' } } },
                            { text: type === FiveWhyType && 'Корневая причина' || 'Корневые причины', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } }
                        ]);
                        const editors = card5Way.Editors.split(";");
                        let editorsRows: any = [];
                        editors.forEach((email: string, idx: number) => {
                            rowHHeight = [...rowHHeight, 0.6]
                            if (idx === 0) {
                                editorsRows = [...editorsRows, [{ text: '', options: { align: "left", colspan: 2, border: { type: 'solid', color: '004465' } } }, {
                                    text: (card5WayTree.some((treeItem: any) => treeItem.root || treeItem.system) && `${card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).map((treeItem: any, idx: number) => {
                                        if (type !== FiveWhyType) {
                                            return `${idx + 1} ${treeItem.reason}`
                                        } else {
                                            return treeItem.reason
                                        }
                                    }).join('\n')}` || 'Корневая причина не найдена'), options: { rowspan: editors.length, align: "left", border: { type: 'solid', color: '004465' } }
                                }]]
                            } else {
                                editorsRows = [...editorsRows, [{ text: '', options: { align: "left", colspan: 2, border: { type: 'solid', color: '004465' } } }]]
                            }
                        });
                        rows = [...rows, ...editorsRows];
                        slide.addTable(rows, { colW: [2.4, 4.6, 15], w: 22, align: 'center', rowH: rowHHeight, fontSize: 20, x: 0, y: 0, valign: 'middle' });
                        rows = [];
                        rows.push([
                            { text: type === FiveWhyType && 'Триггер 5Почему' || 'Триггер Отчета об отклонении', options: { align: "center", color: "ffffff", fill: '00629B', colspan: 2, border: { type: 'solid', color: '004465' } } },
                            { text: 'SDCA и действия', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } },
                        ]);
                        let tempTriggers: any = [];
                        if (type === FiveWhyType) {
                            tempTriggers = [...triggers];
                        } else {
                            tempTriggers = [...triggersDeviationReport];
                        }
                        rows.push([
                            { text: tempTriggers.filter((trigger: any) => trigger.ID === card5Way.Trigger).length > 0 && tempTriggers.filter((trigger: any) => trigger.ID === card5Way.Trigger)[0]['Title'], options: { align: "center", colspan: 2, border: { type: 'solid', color: '004465' } } },
                            { text: '', options: { align: "center", color: "ffffff", fill: 'ffffff', border: { type: 'none' } } },
                        ]);
                        rows.push([
                            { text: 'KPI', options: { align: "center", color: "ffffff", fill: '00629B', colspan: 2, border: { type: 'solid', color: '004465' } } },
                            { text: '', options: { align: "center", color: "ffffff", fill: 'ffffff', border: { type: 'none' } } },
                        ]);
                        rows.push([
                            { text: card5Way.KPI.Title, options: { align: "center", colspan: 2, border: { type: 'solid', color: '004465' } } },
                            { text: '', options: { align: "center", color: "ffffff", fill: 'ffffff', border: { type: 'none' } } },
                        ]);
                        rows.push([
                            { text: 'Повторяющаяся проблема?', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } },
                            { text: 'План реагирования выполнен?', options: { align: "center", color: "ffffff", fill: '00629B', border: { type: 'solid', color: '004465' } } },
                            { text: '', options: { align: "center", color: "ffffff", fill: 'ffffff', border: { type: 'none' } } },
                        ]);
                        rows.push([
                            { text: card5Way.ProblemRepeat && 'Да' || 'Нет', options: { align: "center", border: { type: 'solid', color: '004465' } } },
                            // { text: card5Way.Plan, options: { align: "center", border: { type: 'solid', color: '004465' } } },
                            { text: '', options: { align: "center", color: "ffffff", fill: 'ffffff', border: { type: 'none' } } },
                            { text: '', options: { align: "center", color: "ffffff", fill: 'ffffff', border: { type: 'none' } } },
                        ]);
                        rows.push([
                            { text: 'Детальное описание проблемы', options: { align: "center", color: "ffffff", fill: '00629B', colspan: 2, border: { type: 'solid', color: '004465' } } },
                            { text: '', options: { align: "center", color: "ffffff", fill: 'ffffff', border: { type: 'none' } } },
                        ]);
                        rows.push([
                            { text: card5Way.Details, options: { align: "left", colspan: 2, border: { type: 'solid', color: '004465' } } },
                            { text: '', options: { align: "center", color: "ffffff", fill: 'ffffff', border: { type: 'none' } } },
                        ]);
                        slide.addTable(rows, { colW: [3.5, 3.5, 15], w: 22, align: 'left', y: findSum(rowHHeight), fontSize: 20, x: 0, rowH: [0.6, 0.6, 0.6, 0.6, 0.6, 0.6, 0.6], valign: 'middle' });
                        rows = [];
                        if (type === FiveWhyType) {
                            if (Card5WayWithActions.actions.length > 0) {
                                rows.push([
                                    { text: 'SDCA', options: { bold: true, align: "left" } },
                                    { text: 'Описание', options: { bold: true, align: "left" } },
                                    { text: 'Срок', options: { bold: true, align: "left" } },
                                    { text: 'Ответственный', options: { bold: true, align: "left" } },
                                ]);
                                Card5WayWithActions.actions.forEach((action: any) => {
                                    rows.push([
                                        { text: action.sdca, options: { align: "left" } },
                                        { text: action.description, options: { align: "left" } },
                                        { text: action.date, options: { align: "left" } },
                                        { text: action.responsible, options: { align: "left" } },
                                    ])
                                });
                                slide.addTable(rows, { colW: [2, 5.4, 3.75, 2.75], x: 7.1, w: 15, y: findSum(rowHHeight) + 0.6, rowH: 0.54, fontSize: 20, border: { type: 'solid', color: '004465' }, valign: 'middle' });
                            }
                        } else {
                            if (Card5WayWithActions.actions.length > 0) {
                                rows.push([
                                    { text: '№ Причины', options: { bold: true, align: "left" } },
                                    { text: 'SDCA', options: { bold: true, align: "left" } },
                                    { text: 'Описание', options: { bold: true, align: "left" } },
                                    { text: 'Срок', options: { bold: true, align: "left" } },
                                    { text: 'Ответственный', options: { bold: true, align: "left" } },
                                ]);
                                Card5WayWithActions.actions.forEach((action: any) => {
                                    rows.push([
                                        { text: action.numRoot, options: { align: "left" } },
                                        { text: action.sdca, options: { align: "left" } },
                                        { text: action.description, options: { align: "left" } },
                                        { text: action.date, options: { align: "left" } },
                                        { text: action.responsible, options: { align: "left" } },
                                    ])
                                });
                                slide.addTable(rows, { colW: [2, 2, 4.4, 2.75, 2.75], x: 7.1, w: 15, y: findSum(rowHHeight) + 0.6, rowH: 0.54, fontSize: 20, border: { type: 'solid', color: '004465' }, valign: 'middle' });
                            }
                        }
                        let slideTree = pptx.addSlide();
                        rows = [];
                        rows.push([
                            { text: `#${card5Way.ID}`, options: { align: "center", color: "ffffff", fill: '004465', hyperlink: { url: type === FiveWhyType && `${siteUrl}/dashboard/3/5-whys?5WayCard=${card5Way.ID}` || `${siteUrl}/dashboard/3/deviation-reports?deviationCard=${card5Way.ID}` } } },
                            { text: card5Way.Date5Way.format('DD.MM.YYYY'), options: { align: "center", color: "ffffff", fill: '004465' } },
                            { text: type === FiveWhyType && '5ПОЧЕМУ' || 'ОТЧЕТ ОБ ОТКЛОНЕНИИ', options: { align: "center", color: "ffffff", fill: '004465' } }
                        ]);
                        slideTree.addTable(rows, { colW: [2.4, 4.6, 15], w: 22, align: 'center', rowH: 0.75, fontSize: 20, x: 0, y: 0, valign: 'middle' });
                        slideTree.addImage({ path: urlScreenshotTree, x: 0, y: 1, h: heightScreen / 96, w: widthScreen / 96 });
                        pptx.writeFile({ fileName: type === FiveWhyType && `5ПОЧЕМУ_${card5Way.ID}` || `ОТЧЕТ_ОБ_ОТКЛОНЕНИИ_${card5Way.ID}` }).then(() => {
                            setPptxLoading(false);
                        });
                    });
                });
            });
        }
    }

    const removeHandle = async () => {
        try {
            setCustomLoading(true);
            setRemoveModal(false);

            // Получаем комментарии
            const commentsResult = await getItemsRequest({
                listName: myTasks5WayCommentsListName,
                filters: { _x0035_Way: card5Way.ID },
            });

            const commentsIds = commentsResult.items.map((comment) => comment.ID);

            //Получаем SDCA
            const sdcaResult = await getItemsRequest({
                listName: myTasksSDCA5WayListName,
                filters: { _x0035_Way: card5Way.ID },
            });

            const sdcaIds = sdcaResult.items.map((sdca) => sdca.ID);

            if (commentsIds.length > 0) {
                // Получаем файлы комментариев
                const filesResult = await getItemsRequest({
                    listName: myTask5WayCommentsFilesListName,
                    filters: { Comment: commentsIds },
                });

                const commentsFilesIds = filesResult.items.map((file) => ({
                    ID: file.ID,
                }));

                // Удаляем файлы, если они есть
                if (commentsFilesIds.length > 0) {
                    await deleteItemRequest({
                        listName: myTask5WayCommentsFilesListName,
                        ID: 0,
                        Ids: commentsFilesIds,
                        fileField: "File",
                    });
                }

                // Удаляем комментарии
                await deleteItemRequest({
                    listName: myTasks5WayCommentsListName,
                    ID: 0,
                    Ids: commentsIds.map((ID) => ({ ID })),
                });
            }

            if (sdcaIds) {
                await deleteItemRequest({
                    listName: myTasksSDCA5WayListName,
                    ID: 0,
                    Ids: sdcaIds.map((ID) => ({ ID })),
                });
            }

            // Удаляем саму карточку
            await deleteItemRequest({
                listName: myTasks5WayListName,
                ID: card5Way.ID,
            });

            setOpen(false);
            navigate(0);
        } catch (error) {
            console.error(error);
        } finally {
            setCustomLoading(false);
        }
    };

    useEffect(() => {
        if (confirmUseAiModal) {
            dispatch(runAIIdle());
        }
    }, [confirmUseAiModal]);

    return (
        <>
            <DrawerComponent hideXMarkIcon={editCardFiveWhy} zIndex={zIndex} open={open} toggleDrawer={setOpen}>
                <>
                    <div className="flex flex-col p-10 pt-5 shrink">
                        {(customLoading || statusCard5Way === 'LOADING' || _.isEmpty(card5Way)) && (
                            <div className="flex items-center justify-center w-full mt-5 mb-5">
                                <Loading />
                            </div>
                        ) ||
                            <>
                                {statusCard5Way === 'SUCCESS' &&
                                    <>
                                        <div className="sticky top-0 z-30 bg-white pt-5">
                                            <FlexRow className="justify-between gap-5 mb-3 relative">
                                                <h1 className="text-black break-words relative z-[3]">{card5Way.Title}</h1>
                                                {existingRateTotalWeight !== null &&
                                                    <div className="mb-4 flex-1">
                                                        <RatingBadge score={existingRateTotalWeight} />
                                                    </div>
                                                }
                                                <FlexRow className="gap-[10px]">
                                                    <Statuses card5WayID={card5WayID} />
                                                    {viewMode &&
                                                        <>
                                                            {editor && Object.keys(editor).length > 0 &&
                                                                <div className="min-w-[320px] max-w-[320px] rounded-lg border p-2 bg-white border-[#DFE4EA]">
                                                                    <span className="font-medium mb-2 block text-sm text-[#F89090]">Эту карточку редактирует</span>
                                                                    <div className="flex gap-2">
                                                                        <UserAvatar
                                                                            avatar={users[editor.Author.Email.toLowerCase()] && users[editor.Author.Email.toLowerCase()].avatar}
                                                                            shortName={users[editor.Author.Email.toLowerCase()] && users[editor.Author.Email.toLowerCase()].displayName && users[editor.Author.Email.toLowerCase()].displayName.split(' ')[0][0] + users[editor.Author.Email.toLowerCase()].displayName.split(' ')[1][0]}
                                                                            displayName={users[editor.Author.Email.toLowerCase()] && users[editor.Author.Email.toLowerCase()].displayName}
                                                                            email={editor.Author.Email.toLowerCase()}
                                                                        />
                                                                        <FlexCol className="justify-center items-start">
                                                                            <span className="text-[#111928]">{users[editor.Author.Email.toLowerCase()] && users[editor.Author.Email.toLowerCase()].displayName}</span>
                                                                            <span className="text-sm text-[#637381]" dangerouslySetInnerHTML={{ __html: users[editor.Author.Email.toLowerCase()] && users[editor.Author.Email.toLowerCase()]['jobTitle'] }} />
                                                                        </FlexCol>
                                                                    </div>
                                                                </div> ||
                                                                <>
                                                                    {type !== FiveWhyType &&
                                                                        <>
                                                                            {(pptxLoading || statusUsers === 'LOADING') &&
                                                                                <FlexCol className="h-[32px] w-[32px]">
                                                                                    <Loading />
                                                                                </FlexCol>
                                                                                ||
                                                                                <TooltipItem position="top-left" tooltipsText="Скачать в Power Point">
                                                                                    <a
                                                                                        href="#"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            importPPTXHandle();
                                                                                        }}
                                                                                        className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                                                                    >
                                                                                        <DownloadWithHoverIcon />
                                                                                    </a>
                                                                                </TooltipItem>
                                                                            }
                                                                        </>
                                                                    }

                                                                </>
                                                            }
                                                        </>
                                                        || <>
                                                            {type === FiveWhyType && card5Way.Status && card5Way.Status.ID !== fiveWhyStatus.closed && card5Way.Status.ID !== fiveWhyStatus.cancel &&
                                                                <TooltipItem position="top-left" tooltipsText="Эскалировать на уровень Отчета об отклонениях">
                                                                    <a
                                                                        href="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            setEscalateModal(true);

                                                                        }}
                                                                        className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                                                    >
                                                                        <SettingsIcon />
                                                                    </a>
                                                                </TooltipItem>
                                                            }
                                                            <>
                                                                {type !== FiveWhyType &&
                                                                    <>
                                                                        {(pptxLoading || statusUsers === 'LOADING') &&
                                                                            <FlexCol className="h-[32px] w-[32px]">
                                                                                <Loading />
                                                                            </FlexCol>
                                                                            ||
                                                                            <TooltipItem position="top-left" tooltipsText="Скачать в Power Point">
                                                                                <a
                                                                                    href="#"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        importPPTXHandle();
                                                                                    }}
                                                                                    className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                                                                >
                                                                                    <DownloadWithHoverIcon />
                                                                                </a>
                                                                            </TooltipItem>
                                                                        }
                                                                    </>
                                                                }

                                                            </>
                                                            {card5Way.Status && card5Way.Status.ID !== fiveWhyStatus.escalate && card5Way.Status.ID !== fiveWhyStatus.cancel &&
                                                                <TooltipItem position="top-left" tooltipsText={type === FiveWhyType && "Отменить 5Почему" || "Отменить Отчет об отлонениях"}>
                                                                    <a

                                                                        href="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            setCancelModal(true);
                                                                        }}
                                                                        className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                                                    >
                                                                        <CancelIcon />
                                                                    </a>
                                                                </TooltipItem>
                                                            }
                                                            {currentUser.incidentAdmin && (
                                                                <TooltipItem
                                                                    position="top-left"
                                                                    tooltipsText={
                                                                        (type === FiveWhyType && "Удалить 5Почему") || "Удалить ОоО"
                                                                    }
                                                                >
                                                                    <a
                                                                        href="#"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            setRemoveModal(true);
                                                                        }}
                                                                        className="flex w-6 h-6 text-[#9CA3AF] hover:text-[#012169]"
                                                                    >
                                                                        <Trash />
                                                                    </a>
                                                                </TooltipItem>
                                                            )}
                                                        </>
                                                    }
                                                </FlexRow>
                                            </FlexRow>
                                            <>
                                                {/* { && (!editor || Object.keys(editor).length === 0)} */}
                                                {!editCardFiveWhy &&
                                                    <>
                                                        {showEditModeBtns &&
                                                            <FlexRow className="w-full justify-between gap-5 mb-5">
                                                                <Button
                                                                    classBg="btn-white"
                                                                    shadow={true}
                                                                    text="Закрыть"
                                                                    open={open}
                                                                    setOpen={setOpen}
                                                                />
                                                                <FlexRow className="gap-5">
                                                                    {card5Way.Incident && type === FiveWhyType &&
                                                                        <Button
                                                                            classBg="btn-white"
                                                                            shadow={true}
                                                                            icon={true}
                                                                            typeIcon="incident"
                                                                            text="Перейти к Несоответствию"
                                                                            customFunction={() => { window.open(`${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${card5Way.Incident.ID}`, "_blank") }}
                                                                        />
                                                                    }
                                                                    {card5Way.Incident && type === 'DeviationReport' &&
                                                                        <Button
                                                                            classBg="btn-white"
                                                                            shadow={true}
                                                                            icon={true}
                                                                            typeIcon="incident"
                                                                            text="Перейти к Инциденту"
                                                                            customFunction={() => { window.open(`${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${card5Way.Incident.ID}`, "_blank") }}
                                                                        />
                                                                    }
                                                                    {card5Way.Status && card5Way.Status.ID === fiveWhyStatus.cancel &&
                                                                        <Button
                                                                            open={returnToWorkModal}
                                                                            setOpen={setReturnToWorkModal}
                                                                            classBg="btn-dark"
                                                                            icon={true}
                                                                            typeIcon="return"
                                                                            shadow={true}
                                                                            text="Вернуть в работу"
                                                                        /> ||
                                                                        <>
                                                                            {type === 'DeviationReport' && card5Way.Escalate &&
                                                                                <Button
                                                                                    classBg="btn-white"
                                                                                    shadow={true}
                                                                                    text="Перейти к 5Почему"
                                                                                    customFunction={navigate}
                                                                                    paramsCustomFunction={`/dashboard/3/5-whys?5WayCard=${card5Way.Escalate.ID}`}
                                                                                />
                                                                            }
                                                                            {type === FiveWhyType && card5Way.Escalate &&
                                                                                <Button
                                                                                    classBg="btn-white"
                                                                                    shadow={true}
                                                                                    text="Перейти к Отчету об отклонениях"
                                                                                    customFunction={navigate}
                                                                                    paramsCustomFunction={`/dashboard/3/deviation-reports?deviationCard=${card5Way.Escalate.ID}`}
                                                                                />
                                                                            }
                                                                            <FlexRow className="gap-5">
                                                                                <Button
                                                                                    classBg="btn-white"
                                                                                    shadow={true}
                                                                                    text={
                                                                                        hasExistingRate
                                                                                            ? (type === FiveWhyType ? "Посмотреть оценку 5Почему" : "Посмотреть оценку ОоО")
                                                                                            : (type === FiveWhyType ? "Оценить 5Почему" : "Оценить Отчет об отклонении")
                                                                                    }
                                                                                    customFunction={() => { setRateDrawerViewMode(viewMode); setOpenRateDrawer(true); }}
                                                                                />
                                                                                {/* <Button
                                                                    classBg="btn-dark"
                                                                    text="Редактировать"
                                                                    customFunction={addEditorHandle}
                                                                    paramsCustomFunction={card5WayID}
                                                                /> */}
                                                                            </FlexRow>
                                                                        </>
                                                                    }
                                                                </FlexRow>
                                                            </FlexRow> ||
                                                            <FlexRow className="w-full justify-between gap-5 mb-5">
                                                                <Button
                                                                    classBg="btn-white"
                                                                    shadow={true}
                                                                    text="Закрыть"
                                                                    open={open}
                                                                    setOpen={setOpen}
                                                                />
                                                                {card5Way.Incident && type === FiveWhyType &&
                                                                    <Button
                                                                        classBg="btn-white"
                                                                        shadow={true}
                                                                        icon={true}
                                                                        typeIcon="incident"
                                                                        text="Перейти к Несоответствию"
                                                                        customFunction={() => { window.open(`${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${card5Way.Incident.ID}`, "_blank") }}
                                                                    />
                                                                }
                                                                {card5Way.Incident && type === 'DeviationReport' &&
                                                                    <Button
                                                                        classBg="btn-white"
                                                                        shadow={true}
                                                                        icon={true}
                                                                        typeIcon="incident"
                                                                        text="Перейти к Инциденту"
                                                                        customFunction={() => { window.open(`${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${card5Way.Incident.ID}`, "_blank") }}
                                                                    />
                                                                }
                                                                {type === FiveWhyType && card5Way.Escalate &&
                                                                    <Button
                                                                        classBg="btn-white"
                                                                        shadow={true}
                                                                        text="Перейти к Отчету об отклонениях"
                                                                        customFunction={navigate}
                                                                        paramsCustomFunction={`/dashboard/3/deviation-reports?deviationCard=${card5Way.Escalate.ID}`}
                                                                    />
                                                                }
                                                                {type === 'DeviationReport' && card5Way.Escalate &&
                                                                    <Button
                                                                        classBg="btn-white"
                                                                        shadow={true}
                                                                        text="Перейти к 5Почему"
                                                                        customFunction={navigate}
                                                                        paramsCustomFunction={`/dashboard/3/5-whys?5WayCard=${card5Way.Escalate.ID}`}
                                                                    />
                                                                }
                                                                {hasExistingRate &&
                                                                    <Button
                                                                        classBg="btn-white"
                                                                        shadow={true}
                                                                        text={type === FiveWhyType ? "Посмотреть оценку 5Почему" : "Посмотреть оценку ОоО"}
                                                                        customFunction={() => { setRateDrawerViewMode(true); setOpenRateDrawer(true); }}
                                                                    />
                                                                }
                                                                {/* {card5Way.Status && card5Way.Status.ID === fiveWhyStatus.cancel &&
                                                        <Button
                                                            open={returnToWorkModal}
                                                            setOpen={setReturnToWorkModal}
                                                            classBg="btn-dark"
                                                            icon={true}
                                                            typeIcon="return"
                                                            shadow={true}
                                                            text="Вернуть в работу"
                                                        />
                                                    } */}
                                                            </FlexRow>
                                                        }
                                                    </>
                                                }
                                            </>
                                        </div>
                                        {!viewMode &&
                                            <Form
                                                type="5way_card_my_tasks"
                                                setFormData={setFormData}
                                                fieldsForm={fields}
                                                defaultValues={defaultValues}
                                                setDependenceFields={setDependenceFields}
                                                setDependenceFields5Way={setDependenceFields5Way}
                                                setDetailProblem={setDetailProblem}
                                                kpi={kpi}
                                                type5way={type}
                                                ID5WayAdd={card5WayID}
                                                card5WayTree={card5WayTree}
                                                setCard5WayTree={setCard5WayTree}
                                                openTree={openTree}
                                                setOpenTree={setOpenTree}
                                                zIndex={zIndex}
                                                openCancelAddCard={viewMode}
                                                setOpenCancelAddCard={setViewMode}
                                                removeEditorHandle={removeEditorHandle}
                                                extraButtonText={type === FiveWhyType ? "Оценить 5Почему" : "Оценить Отчет об отклонении"}
                                                extraButtonAction={() => { setRateDrawerViewMode(false); setOpenRateDrawer(true); }}
                                                setEditCardFiveWhy={setEditCardFiveWhy}
                                                problemInTree={problemInTree}
                                                setProblemInTree={setProblemInTree}
                                                setProblevRepeatCounShow={setProblevRepeatCounShow}
                                                setConfirmUseAiModal={setConfirmUseAiModal}
                                            />
                                            || <FlexRow className="flex-wrap justify-between w-full">
                                                {fields.filter(field => !field.hide).map((field: any) => (
                                                    <div className={`${field.width} mb-5`}>
                                                        {((field.key === 'Actions' || field.key === 'Details') && type === FiveWhyType) &&
                                                            <></> ||
                                                            <label className="flex flex-row justify-between text-sm font-medium leading-6 text-gray-900">
                                                                <span>{field.title}</span>
                                                            </label>
                                                        }
                                                        <div className="mt-2">
                                                            {field.key === 'Date5Way' &&
                                                                <span>{moment(card5Way[field.key]).format('DD.MM.YYYY')}</span>
                                                                || (field.key === 'Department' || field.key === 'Location' || field.key === 'KPI' || field.key === 'Region') &&
                                                                <span>{card5Way[field.key]['Title']}</span>
                                                                || field.key === 'Trigger' &&
                                                                <span>{tempTriggers.filter((trigger: any) => trigger.ID === card5Way[field.key]).length > 0 && tempTriggers.filter((trigger: any) => trigger.ID === card5Way[field.key])[0]['Title'] || ""}</span>
                                                                || (field.key === 'Editors') &&
                                                                <>
                                                                    <FlexRow onClick={() => setShowEditors(!showEditors)} className="w-full flex justify-between items-center mb-5">
                                                                        <h3 className="text-[#637381] flex items-center font-medium">Участники · {card5Way[field.key] && card5Way[field.key].split(";").length || 0}</h3>
                                                                        {card5Way[field.key] && card5Way[field.key].split(";").length > 1 &&
                                                                            <>
                                                                                {!showEditors &&
                                                                                    <ArrowDown />
                                                                                    ||
                                                                                    <ArrowUp />
                                                                                }
                                                                            </>
                                                                        }
                                                                    </FlexRow>
                                                                    {!showEditors &&
                                                                        <div className="flex flex-col flex-wrap w-full mb-2.5 relative gap-2">
                                                                            {card5Way[field.key] && card5Way[field.key].split(";").length > 3 &&
                                                                                <>
                                                                                    <div className="grid grid-cols-3 w-full mb-2.5 relative gap-2">
                                                                                        {card5Way[field.key].split(";").map((email: string, idx: number) => (
                                                                                            <>
                                                                                                {idx <= 2 && (
                                                                                                    <>
                                                                                                        {users[email] ? (
                                                                                                            <FlexRow
                                                                                                                className="w-full rounded-lg border p-5 bg-white justify-between items-center border-[#DFE4EA]"
                                                                                                            >
                                                                                                                <div className="flex items-center gap-2">
                                                                                                                    <UserAvatar
                                                                                                                        avatar={users[email]?.avatar}
                                                                                                                        shortName={
                                                                                                                            users[email]?.displayName &&
                                                                                                                            users[email].displayName.split(" ")[0][0] +
                                                                                                                            users[email].displayName.split(" ")[1][0]
                                                                                                                        }
                                                                                                                        displayName={users[email]?.displayName}
                                                                                                                        email={email}
                                                                                                                    />

                                                                                                                    <div className="flex flex-col items-start justify-center">
                                                                                                                        <span className={twMerge(
                                                                                                                            "text-sm text-[#111928]",
                                                                                                                            idx === 0 && "font-bold"
                                                                                                                        )}>
                                                                                                                            {users[email]?.displayName}
                                                                                                                        </span>

                                                                                                                        <span
                                                                                                                            className="text-sm text-[#637381]"
                                                                                                                            dangerouslySetInnerHTML={{
                                                                                                                                __html: users[email]?.jobTitle,
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </FlexRow>
                                                                                                        ) : (
                                                                                                            <div className="flex items-center gap-2">
                                                                                                                Получаем данные о пользователе...
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </>
                                                                                        ))}
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                            {card5Way[field.key] && card5Way[field.key].split(";").length <= 3 &&
                                                                                <>
                                                                                    <div className="grid grid-cols-3 w-full mb-2.5 relative gap-2">
                                                                                        {card5Way[field.key].split(";").map((email: string, idx: number) => (
                                                                                            <>
                                                                                                {users[email] ? (
                                                                                                    <FlexRow
                                                                                                        className="w-full rounded-lg border p-5 bg-white justify-between items-center border-[#DFE4EA]"
                                                                                                    >
                                                                                                        <div className="flex items-center gap-2">
                                                                                                            <UserAvatar
                                                                                                                avatar={users[email]?.avatar}
                                                                                                                shortName={
                                                                                                                    users[email]?.displayName &&
                                                                                                                    users[email].displayName.split(" ")[0][0] +
                                                                                                                    users[email].displayName.split(" ")[1][0]
                                                                                                                }
                                                                                                                displayName={users[email]?.displayName}
                                                                                                                email={email}
                                                                                                            />

                                                                                                            <div className="flex flex-col items-start justify-center">
                                                                                                                <span className={twMerge(
                                                                                                                    "text-sm text-[#111928]",
                                                                                                                    idx === 0 && "font-bold"
                                                                                                                )}>
                                                                                                                    {users[email]?.displayName}
                                                                                                                </span>

                                                                                                                <span
                                                                                                                    className="text-sm text-[#637381]"
                                                                                                                    dangerouslySetInnerHTML={{
                                                                                                                        __html: users[email]?.jobTitle,
                                                                                                                    }}
                                                                                                                />
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </FlexRow>
                                                                                                ) : (
                                                                                                    <div className="flex items-center gap-2">
                                                                                                        Получаем данные о пользователе...
                                                                                                    </div>
                                                                                                )}
                                                                                            </>
                                                                                        ))}
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                        </div>
                                                                    }
                                                                    {showEditors &&
                                                                        <div className="grid grid-cols-3 w-full mb-2.5 relative gap-2">
                                                                            {card5Way[field.key] && card5Way[field.key].split(";").length > 0 &&
                                                                                card5Way[field.key].split(";").map((email: string, idx: number) => (
                                                                                    <>
                                                                                        {users[email] ? (
                                                                                            <FlexRow
                                                                                                className="w-full rounded-lg border p-5 bg-white justify-between items-center border-[#DFE4EA]"
                                                                                            >
                                                                                                <div className="flex items-center gap-2">
                                                                                                    <UserAvatar
                                                                                                        avatar={users[email]?.avatar}
                                                                                                        shortName={
                                                                                                            users[email]?.displayName &&
                                                                                                            users[email].displayName.split(" ")[0][0] +
                                                                                                            users[email].displayName.split(" ")[1][0]
                                                                                                        }
                                                                                                        displayName={users[email]?.displayName}
                                                                                                        email={email}
                                                                                                    />

                                                                                                    <div className="flex flex-col items-start justify-center">
                                                                                                        <span className={twMerge(
                                                                                                            "text-sm text-[#111928]",
                                                                                                            idx === 0 && "font-bold"
                                                                                                        )}>
                                                                                                            {users[email]?.displayName}
                                                                                                        </span>

                                                                                                        <span
                                                                                                            className="text-sm text-[#637381]"
                                                                                                            dangerouslySetInnerHTML={{
                                                                                                                __html: users[email]?.jobTitle,
                                                                                                            }}
                                                                                                        />
                                                                                                    </div>
                                                                                                </div>
                                                                                            </FlexRow>
                                                                                        ) : (
                                                                                            <div className="flex items-center gap-2">
                                                                                                Получаем данные о пользователе...
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                ))}
                                                                        </div>
                                                                    }
                                                                </> || ((field.key === 'Actions' || field.key === 'Details') && type !== FiveWhyType) &&
                                                                <>
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: card5Way[field.key] && card5Way[field.key].replace(
                                                                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                                                                '<span style="color: rgb(0,98,155)">$&</span>'
                                                                            ) || "",
                                                                        }}
                                                                    />
                                                                    {field.key === 'Actions' &&
                                                                        <FlexCol className="w-full my-5 mb-5 p-5 bg-[#F3F4F6] gap-2">
                                                                            <h3 className="text-[#637381] font-medium mb-2.5">Немедленные корректирующие действия и эффект от них</h3>
                                                                            <AddActionInComponent
                                                                                viewMode={true} typeModule="Отчет_об_отклонениях"
                                                                                idModule={card5WayID && `${card5WayID}A` || 0}
                                                                                CustomStyles={"bg-white p-5"}
                                                                            />
                                                                        </FlexCol>
                                                                    }
                                                                </> || ((field.key === 'Actions' || field.key === 'Details') && type === FiveWhyType) &&
                                                                <>
                                                                    {field.key === 'Actions' &&
                                                                        <label className="block mb-2">
                                                                            <div className="flex items-start gap-1">
                                                                                <span className="text-[18px] font-medium text-[#111928]" dangerouslySetInnerHTML={{
                                                                                    __html: params.length > 0 && JSON.parse(params
                                                                                        .find((param: any) => param.Key === "FiveWhyFormStep2")
                                                                                    ["Comments"].trim())['title']
                                                                                }} />
                                                                            </div>
                                                                            <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                                                                                __html: params.length > 0 && JSON.parse(params
                                                                                    .find((param: any) => param.Key === "FiveWhyFormStep2")
                                                                                ["Comments"].trim())['description']
                                                                            }} />
                                                                        </label>
                                                                    }
                                                                    {field.key === 'Details' &&
                                                                        <label className="block mb-2">
                                                                            <div className="flex items-start gap-1">
                                                                                <span className="text-[18px] font-medium text-[#111928]" dangerouslySetInnerHTML={{
                                                                                    __html: params.length > 0 && JSON.parse(params
                                                                                        .find((param: any) => param.Key === "FiveWhyFormStep1")
                                                                                    ["Comments"].trim())['title']
                                                                                }} />
                                                                            </div>
                                                                            <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                                                                                __html: params.length > 0 && JSON.parse(params
                                                                                    .find((param: any) => param.Key === "FiveWhyFormStep1")
                                                                                ["Comments"].trim())['description']
                                                                            }} />
                                                                        </label>
                                                                    }
                                                                    <div
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: card5Way[field.key] && card5Way[field.key].replace(
                                                                                /(^|\W)(#[а-я\w][а-я\w-]*)/gi,
                                                                                '<span style="color: rgb(0,98,155)">$&</span>'
                                                                            ) || "",
                                                                        }}
                                                                    />
                                                                </>
                                                                || field.key === 'ProblemRepeat' &&
                                                                <span>{card5Way[field.key] && "Да" || "Нет"}</span>
                                                            }
                                                        </div>
                                                    </div>
                                                ))}
                                                <FlexCol className="mb-5 w-full gap-[10px]">
                                                    {type === FiveWhyType &&
                                                        <>
                                                            <label className="block mb-2">
                                                                <div className="flex items-start gap-1">
                                                                    <span className="text-[18px] font-medium text-[#111928]" dangerouslySetInnerHTML={{
                                                                        __html: params.length > 0 && JSON.parse(params
                                                                            .find((param: any) => param.Key === "FiveWhyFormStep3")
                                                                        ["Comments"].trim())['title']
                                                                    }} />
                                                                </div>
                                                                <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                                                                    __html: params.length > 0 && JSON.parse(params
                                                                        .find((param: any) => param.Key === "FiveWhyFormStep3")
                                                                    ["Comments"].trim())['description']
                                                                }} />
                                                            </label>
                                                            {card5WayTree.some((treeItem: any) => treeItem.root || treeItem.system) &&
                                                                <FlexCol className="p-5 bg-[#F3F4F6] rounded-md mb-2">
                                                                    <span className="text-[#111928] text-sm mb-2"><strong>Корневая причина: </strong></span>
                                                                    <FlexRow className="justify-between">
                                                                        {card5WayTree.filter((treeItem: any) => treeItem.root || treeItem.system).map((treeItem: any, idx: number) => (
                                                                            <>
                                                                                <span style={{ whiteSpace: "pre-wrap" }} className="text-sm">{treeItem.reason}</span>
                                                                                {treeItem.root && (
                                                                                    <FlexRow
                                                                                        title="Корневая причина"
                                                                                        className="text-[#F2A900]"
                                                                                    >
                                                                                        <Medal />
                                                                                    </FlexRow>
                                                                                )
                                                                                }
                                                                            </>
                                                                        ))}
                                                                    </FlexRow>
                                                                </FlexCol>
                                                            }
                                                        </> ||
                                                        <>
                                                            <h3 className="text-[#637381] font-medium">Диаграмма Ишикавы</h3>
                                                            {(card5WayTree.some((treeItem: any) => treeItem.root || treeItem.system) &&
                                                                <>
                                                                    <FlexRow className="justify-center w-full rounded-md bg-[#DAF8E6] border border-[#22AD5C] p-2.5 mb-2.5">
                                                                        Корневая причина найдена
                                                                    </FlexRow>
                                                                    {card5WayTree
                                                                        .filter((treeItem: any) => treeItem.root || treeItem.system)
                                                                        .map((treeItem: any, idx: number) => (
                                                                            <FlexRow className="justify-center w-full gap-[10px] rounded-md bg-[#F3F4F6] p-5">
                                                                                {type !== FiveWhyType &&
                                                                                    <FlexRow className="w-fit"><strong>{idx + 1}.</strong></FlexRow>
                                                                                }
                                                                                <FlexCol className="w-full gap-[10px]">
                                                                                    {treeItem.reason}
                                                                                    <span className="text-[#8646F4]">Категория Ишикавы: {treeItem.category}</span>
                                                                                </FlexCol>
                                                                                {treeItem.root &&
                                                                                    <FlexRow title="Техническая причина" className="text-[#F2A900]">
                                                                                        <Medal />
                                                                                    </FlexRow>
                                                                                }
                                                                                {treeItem.system &&
                                                                                    <FlexRow title="Системная причина" className="text-[#E10E0E]">
                                                                                        <Medal />
                                                                                    </FlexRow>
                                                                                }
                                                                            </FlexRow>
                                                                        ))}
                                                                </>

                                                            ) ||
                                                                <>
                                                                    {type === FiveWhyType &&
                                                                        <FlexRow className="justify-center w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5 mb-2.5">
                                                                            Найдите корневую причину в дереве почему
                                                                        </FlexRow>
                                                                        ||
                                                                        <FlexRow className="justify-center w-full rounded-md bg-[#FEF3C7] border border-[#F2A900] p-2.5 mb-2.5">
                                                                            Проанализируйте проблему и найдите хотя бы одну корневую причину
                                                                        </FlexRow>
                                                                    }
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                    <Tree open={openTree} setOpen={setOpenTree} zIndex={zIndex + 50} setCard5WayTree={setCard5WayTree} type5Way={type} card5WayID={card5WayID} viewMode={true} tree={card5WayTree} detailProplem={detailProplem} />
                                                </FlexCol>
                                                {type !== FiveWhyType &&
                                                    <SDCA card5WayID={card5WayID} viewMode={true} type5Way={type} card5WayTree={card5WayTree} />
                                                    ||
                                                    <>
                                                        <label className="block mb-2">
                                                            <div className="flex items-start gap-1">
                                                                <span className="text-[18px] font-medium text-[#111928]" dangerouslySetInnerHTML={{
                                                                    __html: params.length > 0 && JSON.parse(params
                                                                        .find((param: any) => param.Key === "FiveWhyFormStep4")
                                                                    ["Comments"].trim())['title']
                                                                }} />
                                                            </div>
                                                            <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                                                                __html: params.length > 0 && JSON.parse(params
                                                                    .find((param: any) => param.Key === "FiveWhyFormStep4")
                                                                ["Comments"].trim())['description']
                                                            }} />
                                                        </label>
                                                        <FlexCol className="bg-[#F3F4F6] rounded-md p-5 mb-5 w-full">
                                                            <h3 className="text-lg text-[#637381] font-medium mb-2">Действия</h3>
                                                            <AddActionInComponent
                                                                typeModule="5Почему"
                                                                idModule={(card5WayID && `${card5WayID}`) || 0}
                                                                CustomStyles={"bg-white p-5"}
                                                                typeForm="5way_card_my_tasks"
                                                                viewMode={true}
                                                            />
                                                        </FlexCol>
                                                    </>

                                                }
                                                {type === FiveWhyType &&
                                                    <>
                                                        <label className="block mb-2">
                                                            <div className="flex items-start gap-1">
                                                                <span className="text-[18px] font-medium text-[#111928]" dangerouslySetInnerHTML={{
                                                                    __html: params.length > 0 && JSON.parse(params
                                                                        .find((param: any) => param.Key === "FiveWhyFormStep5")
                                                                    ["Comments"].trim())['title']
                                                                }} />
                                                            </div>
                                                            <p className="mt-1 text-sm text-[#9CA3AF]" dangerouslySetInnerHTML={{
                                                                __html: params.length > 0 && JSON.parse(params
                                                                    .find((param: any) => param.Key === "FiveWhyFormStep5")
                                                                ["Comments"].trim())['description']
                                                            }} />
                                                        </label>
                                                        <Comments
                                                            history={false}
                                                            variant="inlineAdd"
                                                            zIndex={zIndex + 50}
                                                            IDCard={Number(card5WayID)}
                                                            listComments={myTasks5WayCommentsListName}
                                                            listFilesComments={myTask5WayCommentsFilesListName}
                                                            strapiParams={MT5WhyCommentsFiles}
                                                            field="_x0035_Way"
                                                            customClass="mb-5 w-full"
                                                            label=""
                                                        />
                                                    </> ||
                                                    <Comments
                                                        history={false}
                                                        zIndex={zIndex + 50}
                                                        IDCard={Number(card5WayID)}
                                                        listComments={myTasks5WayCommentsListName}
                                                        listFilesComments={myTask5WayCommentsFilesListName}
                                                        strapiParams={MT5WhyCommentsFiles}
                                                        field="_x0035_Way"
                                                        customClass="mb-5 w-full"
                                                    />
                                                }

                                                {/* { && (!editor || Object.keys(editor).length === 0)} */}

                                            </FlexRow>
                                        }
                                        {!editCardFiveWhy &&
                                            <>
                                                <FlexRow className="w-full justify-between gap-5 mb-5">
                                                    {existingRateTotalWeight !== null &&
                                                        <div className="mt-4 w-full">
                                                            <RatingBadge score={existingRateTotalWeight} />
                                                        </div>
                                                    }
                                                </FlexRow>
                                                {showEditModeBtns &&
                                                    <FlexRow className="w-full justify-between gap-5">
                                                        <Button
                                                            classBg="btn-white"
                                                            shadow={true}
                                                            text="Закрыть"
                                                            open={open}
                                                            setOpen={setOpen}
                                                        />
                                                        <FlexRow className="gap-5">
                                                            {card5Way.Incident && type === FiveWhyType &&
                                                                <Button
                                                                    classBg="btn-white"
                                                                    shadow={true}
                                                                    icon={true}
                                                                    typeIcon="incident"
                                                                    text="Перейти к Несоответствию"
                                                                    customFunction={() => { window.open(`${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${card5Way.Incident.ID}`, "_blank") }}
                                                                />
                                                            }
                                                            {card5Way.Incident && type === 'DeviationReport' &&
                                                                <Button
                                                                    classBg="btn-white"
                                                                    shadow={true}
                                                                    icon={true}
                                                                    typeIcon="incident"
                                                                    text="Перейти к Инциденту"
                                                                    customFunction={() => { window.open(`${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${card5Way.Incident.ID}`, "_blank") }}
                                                                />
                                                            }
                                                            {card5Way.Status && card5Way.Status.ID === fiveWhyStatus.cancel &&
                                                                <Button
                                                                    open={returnToWorkModal}
                                                                    setOpen={setReturnToWorkModal}
                                                                    classBg="btn-dark"
                                                                    icon={true}
                                                                    typeIcon="return"
                                                                    shadow={true}
                                                                    text="Вернуть в работу"
                                                                /> ||
                                                                <>
                                                                    {type === 'DeviationReport' && card5Way.Escalate &&
                                                                        <Button
                                                                            classBg="btn-white"
                                                                            shadow={true}
                                                                            text="Перейти к 5Почему"
                                                                            customFunction={navigate}
                                                                            paramsCustomFunction={`/dashboard/3/5-whys?5WayCard=${card5Way.Escalate.ID}`}
                                                                        />
                                                                    }
                                                                    {type === FiveWhyType && card5Way.Escalate &&
                                                                        <Button
                                                                            classBg="btn-white"
                                                                            shadow={true}
                                                                            text="Перейти к Отчету об отклонениях"
                                                                            customFunction={navigate}
                                                                            paramsCustomFunction={`/dashboard/3/deviation-reports?deviationCard=${card5Way.Escalate.ID}`}
                                                                        />
                                                                    }
                                                                    <FlexRow className="gap-5">
                                                                        <Button
                                                                            classBg="btn-white"
                                                                            shadow={true}
                                                                            text={
                                                                                hasExistingRate
                                                                                    ? (type === FiveWhyType ? "Посмотреть оценку 5Почему" : "Посмотреть оценку ОоО")
                                                                                    : (type === FiveWhyType ? "Оценить 5Почему" : "Оценить Отчет об отклонении")
                                                                            }
                                                                            customFunction={() => { setRateDrawerViewMode(viewMode); setOpenRateDrawer(true); }}
                                                                        />
                                                                        {/* <Button
                                                                classBg="btn-dark"
                                                                text="Редактировать"
                                                                customFunction={addEditorHandle}
                                                                paramsCustomFunction={card5WayID}
                                                            /> */}
                                                                    </FlexRow>
                                                                </>
                                                            }
                                                        </FlexRow>
                                                    </FlexRow> ||
                                                    <FlexRow className="w-full justify-between gap-5">
                                                        <Button
                                                            classBg="btn-white"
                                                            shadow={true}
                                                            text="Закрыть"
                                                            open={open}
                                                            setOpen={setOpen}
                                                        />

                                                        {card5Way.Incident && type === FiveWhyType &&
                                                            <Button
                                                                classBg="btn-white"
                                                                shadow={true}
                                                                icon={true}
                                                                typeIcon="incident"
                                                                text="Перейти к Несоответствию"
                                                                customFunction={() => { window.open(`${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${card5Way.Incident.ID}`, "_blank") }}
                                                            />
                                                        }
                                                        {card5Way.Incident && type === 'DeviationReport' &&
                                                            <Button
                                                                classBg="btn-white"
                                                                shadow={true}
                                                                icon={true}
                                                                typeIcon="incident"
                                                                text="Перейти к Инциденту"
                                                                customFunction={() => { window.open(`${siteUrl}/dashboard/3/incidents-and-nonconformities?incidentCard=${card5Way.Incident.ID}`, "_blank") }}
                                                            />
                                                        }
                                                        {type === FiveWhyType && card5Way.Escalate &&
                                                            <Button
                                                                classBg="btn-white"
                                                                shadow={true}
                                                                text="Перейти к Отчету об отклонениях"
                                                                customFunction={navigate}
                                                                paramsCustomFunction={`/dashboard/3/deviation-reports?deviationCard=${card5Way.Escalate.ID}`}
                                                            />
                                                        }
                                                        {type === 'DeviationReport' && card5Way.Escalate &&
                                                            <Button
                                                                classBg="btn-white"
                                                                shadow={true}
                                                                text="Перейти к 5Почему"
                                                                customFunction={navigate}
                                                                paramsCustomFunction={`/dashboard/3/5-whys?5WayCard=${card5Way.Escalate.ID}`}
                                                            />
                                                        }
                                                        {hasExistingRate &&
                                                            <Button
                                                                classBg="btn-white"
                                                                shadow={true}
                                                                text={type === FiveWhyType ? "Посмотреть оценку 5Почему" : "Посмотреть оценку ОоО"}
                                                                customFunction={() => { setRateDrawerViewMode(true); setOpenRateDrawer(true); }}
                                                            />
                                                        }
                                                        {/* {card5Way.Status && card5Way.Status.ID === fiveWhyStatus.cancel &&
                                                        <Button
                                                            open={returnToWorkModal}
                                                            setOpen={setReturnToWorkModal}
                                                            classBg="btn-dark"
                                                            icon={true}
                                                            typeIcon="return"
                                                            shadow={true}
                                                            text="Вернуть в работу"
                                                        />
                                                    } */}
                                                    </FlexRow>
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </>
                        }
                    </div>
                    <DrawerComponent zIndex={zIndex ? zIndex + 10 : 70} open={openRateDrawer} toggleDrawer={setOpenRateDrawer} percentage="79">
                        {openRateDrawer && (
                            <Rate5Why
                                onClose={() => setOpenRateDrawer(false)}
                                onSuccess={(rateId, rateDocumentId, totalWeight) => { setExistingRateId(rateId); setExistingRateDocumentId(rateDocumentId); setExistingRateTotalWeight(totalWeight); }}
                                card5WayID={card5WayID}
                                existingRateId={existingRateId}
                                existingRateDocumentId={existingRateDocumentId}
                                viewMode={rateDrawerViewMode}
                                cardType={type}
                                zIndex={zIndex + 50}
                            />
                        )}
                    </DrawerComponent>
                </>
            </DrawerComponent >
            <Modal hideXMarkIcon={escalateLoading} zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={escalateModal} toggleDialog={setEscalateModal}>
                {!escalateLoading &&
                    <>
                        <header className="px-10 pb-4">
                            <h2>Подтвердите действие</h2>
                        </header>

                        <div className="px-10 py-5">
                            <p>
                                Вы уверены, что хотите эскалировать 5Почему на уровень<br /> Отчета об отклонениях? В таком случае 5Почему нельзя будет<br /> изменить в будущем.<br /><br />Данные из 5Почему в Отчете об отклонениях также будут<br /> недоступны для изменения. В отчете можно будет создать<br /> дерево Почему с факторами Ишикаы и SDCA-инструменты<br /> с действиями.
                            </p>
                        </div>

                        <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
                            <TGButton color="white" onClick={(e) => setEscalateModal(!escalateModal)}>Отмена</TGButton>

                            <TGButton color="bluedark" onClick={escalateHandle}>Эскалировать</TGButton>
                        </footer>
                    </> || <div className="flex items-center justify-center w-full mt-5 mb-5">
                        <Loading />
                    </div>
                }
            </Modal>
            <Modal hideXMarkIcon={cancelLoading} zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={cancelModal} toggleDialog={setCancelModal}>
                {cancelLoading && <div className="flex items-center justify-center w-full mt-5 mb-5">
                    <Loading />
                </div> ||
                    <>
                        {actions.length > 0 && actions.filter((action: any) => action.Status.get_lookupId() !== actionsStatus.cancel && action.Status.get_lookupId() !== actionsStatus.closed).length > 0 &&
                            <>
                                {type === FiveWhyType &&
                                    <>
                                        <header className="px-10 pb-4">
                                            <h2>Невозможно отменить 5Почему</h2>
                                        </header>
                                        <div className="px-10 py-5">
                                            <p>
                                                В 5Почему остались незакрытые действия.<br />
                                                Закройте или отмените действия, чтобы отменить 5Почему.
                                            </p>
                                        </div>
                                        <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                                            <TGButton color="white" onClick={(e) => setCancelModal(!cancelModal)}>Закрыть</TGButton>
                                        </footer>
                                    </>
                                    ||
                                    <>
                                        <header className="px-10 pb-4">
                                            <h2>Невозможно отменить Отчет об отклонениях</h2>
                                        </header>
                                        <div className="px-10 py-5">
                                            <p>
                                                В Отчете об отклонениях остались незакрытые действия.<br />
                                                Закройте или отмените действия, чтобы отменить Отчет.
                                            </p>
                                        </div>
                                        <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                                            <TGButton color="white" onClick={(e) => setCancelModal(!cancelModal)}>Закрыть</TGButton>
                                        </footer>
                                    </>
                                }

                            </> ||
                            <>
                                <header className="px-10 pb-4">
                                    <h2>Подтвердите действие</h2>
                                </header>

                                <div className="px-10 py-5">
                                    {type === FiveWhyType &&
                                        <p>
                                            Вы уверены, что хотите отменить 5Почему?
                                        </p> ||
                                        <p>
                                            Вы уверены, что хотите отменить Отчет об отклонениях?
                                        </p>
                                    }
                                </div>
                                <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
                                    <TGButton color="white" onClick={(e) => setCancelModal(!cancelModal)}>Не отменять</TGButton>
                                    <TGButton color="bluedark" onClick={cancelHandle}>{type === FiveWhyType && "Да, отменить 5Почему" || "Да, отменить Отчет об отклонении"}</TGButton>
                                </footer>
                            </>
                        }
                    </>
                }
            </Modal>
            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={returnToWorkModal} toggleDialog={setReturnToWorkModal}>
                <header className="px-10 pb-4">
                    <h2>Подтвердите действие</h2>
                </header>

                <div className="px-10 py-5">
                    {type === FiveWhyType &&
                        <p>
                            Вы уверены, что хотите вернуть в работу 5Почему?
                        </p> ||
                        <p>
                            Вы уверены, что хотите вернуть в работу Отчет об отклонениях?
                        </p>
                    }
                </div>

                <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setReturnToWorkModal(!returnToWorkModal)}>Не возвращать</TGButton>
                    <TGButton color="bluedark" onClick={returnToWorkHandle}>{type === FiveWhyType && "Да, вернуть 5Почему" || "Да, вернуть Отчет об отклонениях"}</TGButton>
                </footer>
            </Modal>
            <Modal
                zIndex={zIndex ? zIndex + 10 : 70}
                modalClassName="min-h-px"
                open={removeModal}
                toggleDialog={setRemoveModal}
            >
                <header className="px-10 pb-4">
                    <h2>Подтвердите действие</h2>
                </header>

                <div className="px-10 py-5">
                    {(type === FiveWhyType && (
                        <p>Вы уверены, что хотите удалить 5Почему?</p>
                    )) || <p>Вы уверены, что хотите удалить ОоО?</p>}
                </div>
                <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setRemoveModal(!removeModal)}>
                        Не удалять
                    </TGButton>
                    <TGButton color="bluedark" onClick={removeHandle}>
                        Да, удалить
                    </TGButton>
                </footer>
            </Modal>
            <Modal
                zIndex={zIndex ? zIndex + 100 : 70}
                hideXMarkIcon={true}
                modalClassName="min-h-px lg:w-[calc(100vw-100%)]"
                open={confirmUseAiModal}
                toggleDialog={setConfirmUseAiModal}
            >
                <header className="px-10 pb-4">
                    <h2>Подтверждение использования ИИ-помощника</h2>
                </header>

                <div className="px-10 py-5">
                    <p>Вы собираетесь начать диалог с ИИ-ассистентом.<br /><br />
                        Нажимая «Продолжить», вы подтверждаете, что не будете передавать в чат сведения, составляющие коммерческую тайну или конфиденциальную информацию, в нарушение <a href="https://teamly.napitkivmeste.ru/at/62289e85-94b4-4488-abb2-c9ab7d8f6d2e" target="_blank">Политики о коммерческой тайне и конфиденциальной информации</a>.<br /><br />
                        ⚠️ Обратите внимание: ИИ-модель может генерировать неточные ответы. Всегда проверяйте важную информацию.</p>
                </div>

                <footer className="flex justify-between w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setConfirmUseAiModal(false)}>
                        Отмена
                    </TGButton>
                    <TGButton
                        color="bluedark"
                        onClick={(e) => {
                            setConfirmUseAiModal(false);
                            if (localStorage.getItem('typeAI') === 'FiveWhy') {
                                const normalizeText = (text) =>
                                    text
                                        ?.toLowerCase()
                                        .replace(/\s+/g, ' ')
                                        .trim();
                                const problem = normalizeText(detailProplem?.toLowerCase() || "");
                                const requestText = normalizeText(ai?.data?.answer?.RequestText?.toLowerCase());
                                const history = ai?.data?.history || [];
                                const hasSameProblem =
                                    problem &&
                                    (
                                        (requestText && requestText.indexOf(problem) !== -1) ||
                                        history?.some((item) => normalizeText(item?.RequestTextPlain?.toLowerCase()).indexOf(problem) !== -1)
                                    );
                                if (hasSameProblem) {
                                    setBlockAiAgent(true);
                                } else if (detailProplem.length > 5000) {
                                    setBlockAiAgentProblem(true);
                                } else if (!problem) {
                                    setBlockAiAgentNoDetail(true);
                                } else {
                                    dispatch(runAI({ type: 'FiveWhy', data: { id: card5WayID, details: detailProplem } }));
                                }
                            }
                            if (localStorage.getItem('typeAI') === 'FiveWhyTree') {
                                const isValid = card5WayTree.every(item => item.reason?.trim()) && card5WayTree.length > 0;
                                if (isValid) {
                                    dispatch(runAI({ type: 'FiveWhyTree', data: { id: card5WayID, tree: card5WayTree, detailsInTree: problemInTree } }));
                                } else {
                                    setBlockAiAgentNoTree(true);
                                }
                            }
                        }}
                    >
                        Продолжить
                    </TGButton>
                </footer>
            </Modal>
            <Modal
                zIndex={zIndex ? zIndex + 100 : 70}
                modalClassName="min-h-px lg:w-[calc(100vw-100%)]"
                open={blockAiAgent}
                hideXMarkIcon={true}
                toggleDialog={setBlockAiAgent}
            >
                <header className="px-10 pb-4">
                    <h2>Ошибка</h2>
                </header>

                <div className="px-10 py-5">
                    <p>Данная информация уже анализировалась ИИ, ответ Вы можете найти в истории</p>
                </div>

                <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setBlockAiAgent(false)}>
                        Закрыть
                    </TGButton>
                </footer>
            </Modal>
            <Modal
                zIndex={zIndex ? zIndex + 100 : 70}
                modalClassName="min-h-px lg:w-[calc(100vw-100%)]"
                open={blockAiAgentNoDetail}
                hideXMarkIcon={true}
                toggleDialog={setBlockAiAgentNoDetail}
            >
                <header className="px-10 pb-4">
                    <h2>Ошибка</h2>
                </header>

                <div className="px-10 py-5">
                    <p>Необходимо передать в ИИ-помощник детальное описание</p>
                </div>

                <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setBlockAiAgentNoDetail(false)}>
                        Закрыть
                    </TGButton>
                </footer>
            </Modal>
            <Modal
                zIndex={zIndex ? zIndex + 100 : 70}
                modalClassName="min-h-px lg:w-[calc(100vw-100%)]"
                open={blockAiAgentNoTree}
                hideXMarkIcon={true}
                toggleDialog={setBlockAiAgentNoTree}
            >
                <header className="px-10 pb-4">
                    <h2>Ошибка</h2>
                </header>

                <div className="px-10 py-5">
                    <p>Необходимо передать в ИИ-помощник анализ где есть сформированная проблема и хотя бы один Потому что...</p>
                </div>

                <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setBlockAiAgentNoTree(false)}>
                        Закрыть
                    </TGButton>
                </footer>
            </Modal>
            <Modal
                zIndex={zIndex ? zIndex + 100 : 70}
                modalClassName="min-h-px lg:w-[calc(100vw-100%)]"
                open={blockAiAgentProblem}
                hideXMarkIcon={true}
                toggleDialog={setBlockAiAgentProblem}
            >
                <header className="px-10 pb-4">
                    <h2>Ошибка</h2>
                </header>

                <div className="px-10 py-5">
                    <span className="text-[#BA0C2F] text-sm">Превышено максимальное количество символов: {detailProplem.length}/5000</span>
                </div>

                <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setBlockAiAgentProblem(false)}>
                        Закрыть
                    </TGButton>
                </footer>
            </Modal>
        </>
    );
};

export default Card5Way;
